import script from "./DomainModelQueryInputs.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainModelQueryInputs.vue?vue&type=script&setup=true&lang=js"

import "./DomainModelQueryInputs.vue?vue&type=style&index=0&id=265f04ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-265f04ee"]])

export default __exports__